import serverApi from "../utils/serverApi"

const locationsService = {
  getGeoLocation: () => serverApi({ uri: "get-geolocation", method: "GET", isLoading: false }),

  getLocations: () => serverApi({ uri: "locations", method: "GET", isLoading: false }),
}

export default locationsService
